import React, { useEffect, useMemo } from "react";
import useStyles from "./style";
import { Grid, Typography } from "@mui/material";
import { Person } from "@mui/icons-material";
import moment from "moment-timezone";
import Carousel from "react-material-ui-carousel";
import { CUSTOM_CONSTANTS } from "Constants";

const Estimatedcarousel = ({ distance, duration, services, timezone, setTravelduration, setActiveService }) => {
  const classes = useStyles();

  // ✅ Parse distance/duration safely
  const traveldistance = useMemo(
    () => parseFloat(distance?.replace("km", "").trim()) || 0,
    [distance]
  );

  const travelduration = useMemo(() => {
    let minutes = 0;
    const parts = duration?.match(/(\d+)\s*hours?|\d+\s*mins?/g);
    if (parts) {
      for (const part of parts) {
        if (part.includes("hour")) minutes += parseInt(part) * 60;
        else if (part.includes("min")) minutes += parseInt(part);
      }
    }
    return minutes;
  }, [duration]);

  // ✅ Tell parent duration only when it changes
  useEffect(() => {
    setTravelduration(travelduration);
  }, [travelduration, setTravelduration]);

  // ✅ Build service fares only once per inputs
  const serviceFares = useMemo(() => {
    return services?.map((service) => {
      const { fareDetails, serviceName, serviceImage, serviceImageDecription, seatsAvailable, serviceDescritpion, _id, ...other } =
        service;

      const distanceprice = fareDetails.daytime.unitPrice * traveldistance;
      const timeprice = fareDetails.daytime.minutePrice * travelduration;
      const addToFarePrice = parseFloat((((distanceprice + timeprice) * fareDetails.daytime.addtofare) / 100).toFixed(2));

      const totalfare = distanceprice + timeprice + addToFarePrice + fareDetails.daytime.basePrice;

      const estimated_fare = parseFloat(totalfare.toFixed(2));

      const currentTime = moment.tz(timezone);
      const dropOffTime = currentTime.clone().add(travelduration, "minutes").format("hh:mm A");

      return {
        ...other,
        service_id: _id,
        description: serviceDescritpion,
        service_image: serviceImage,
        service_image_description: serviceImageDecription,
        seats_available: seatsAvailable,
        service_name: serviceName,
        drop_off_time: dropOffTime,
        estimated_fare,
        distance,
      };
    });
  }, [services, traveldistance, travelduration, distance, timezone]);

  // ✅ Set default active service only once
  useEffect(() => {
    if (serviceFares?.length > 0) {
      setActiveService((prev) => prev || serviceFares[0]);
    }
  }, [serviceFares, setActiveService]);

  return (
    <Carousel
      className={classes.estimatedcarousel}
      autoPlay={false}
      navButtonsAlwaysVisible
      indicators={false}
      navButtonsProps={{
        style: { backgroundColor: "#262626", borderRadius: 63, width: "20px", height: "20px" },
      }}
      navButtonsWrapperProps={{
        style: { bottom: "0", top: "unset" },
      }}
      onChange={(now) => setActiveService(serviceFares[now])}
    >
      {serviceFares?.map((service, index) => (
        <Grid container spacing={2} className={classes.Carouselcontainer} key={index}>
          <Grid item xs={6} className={classes.Carouselgrids}>
            <img src={service.service_image} alt={service.service_name} className={classes.carouselimages} loading="lazy" />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1" className={classes.Carouselcontent}>
              <strong>Drop off:</strong> {service.drop_off_time || "loading..."}
            </Typography>
            <Typography variant="body1" className={classes.Carouselcontent}>
              <strong>Estimated amount:</strong>{" "}
              {service.estimated_fare ? service.estimated_fare + CUSTOM_CONSTANTS.BASE_CURRENCY : CUSTOM_CONSTANTS.BASE_CURRENCY}
            </Typography>
            <Typography variant="body1" className={classes.Carouselcontent}>
              <strong>{service.service_name}</strong> <Person /> {service.seats_available}
            </Typography>
          </Grid>
        </Grid>
      ))}
    </Carousel>
  );
};

export default Estimatedcarousel;
